import React from "react";

const numeros = [
  {
    rotulo: "Sistema sob medida",
    valor: "60%",
    texto: "mais receita por funcionário nas pequenas empresas com uso avançado de tecnologia, em comparação com as de uso básico. E 50% mais chance de estar crescendo.",
    fonte: "Deloitte Access Economics, Connected Small Businesses 2017, 1.534 empresas",
    url: "https://www.deloitte.com/content/dam/assets-zone1/au/en/docs/services/economics/deloitte-au-economics-connected-small-businesses-google-161017.pdf",
  },
  {
    rotulo: "Processos automatizados",
    valor: "90%",
    texto: "das organizações que automatizaram processos relataram ganho de qualidade e precisão, e 86% ganho de produtividade. O investimento se pagou em menos de 12 meses.",
    fonte: "Deloitte, Global RPA Survey 2017, 400 organizações",
    url: "https://www2.deloitte.com/uk/en/pages/consulting/articles/the-robots-are-ready-are-you.html",
  },
  {
    rotulo: "Ferramentas conectadas",
    valor: "1.200",
    texto: "trocas de tela por dia é o que uma pessoa faz entre ferramentas que não conversam entre si. Dá 4 horas por semana só para se reorientar.",
    fonte: "Harvard Business Review, 2022, 137 profissionais em três empresas da Fortune 500",
    url: "https://hbr.org/2022/08/how-much-time-and-energy-do-we-waste-toggling-between-applications",
  },
];

const Numbers = () => {
  return (
    <div id="numeros">
      <div className="fade-storm-to-blue" aria-hidden="true" />
      <div className="bg-pattern-fade-storm text-white">
      <div className="w-3/4 mx-auto xl:py-48 py-24">
        <h2 className="text-3xl xl:text-5xl font-semibold xl:text-center mb-12 xl:mb-20">O que os números dizem</h2>
        <ul className="grid grid-cols-1 md:grid-cols-3 gap-12 xl:gap-16">
          {numeros.map((n) => (
            <li key={n.valor}>
              <p className="text-sm font-semibold uppercase tracking-widest text-white/70 mb-3">{n.rotulo}</p>
              <p className="font-display text-5xl xl:text-6xl font-bold text-secondary mb-4">{n.valor}</p>
              <p className="text-lg xl:text-xl leading-relaxed mb-4">{n.texto}</p>
              <p className="text-sm text-white/70">
                <a href={n.url} target="_blank" rel="noopener noreferrer" className="underline hover:text-white">
                  {n.fonte}
                </a>
              </p>
            </li>
          ))}
        </ul>
      </div>
      </div>
      <div className="fade-blue-to-gray" aria-hidden="true" />
    </div>
  );
};

export default Numbers;
